import { Pipe, PipeTransform } from "@angular/core";

export interface DistanceTrajet {
  km: number;
  m: number;
}

@Pipe({
  name: "distanceTrajet",
  standalone: false,
})
export class DistanceTrajetPipe implements PipeTransform {
  transform(value: DistanceTrajet | null | undefined): string {
    if (!value || (value.km == null && value.m == null)) return "0 m";
    const km = value.km ?? 0;
    const m = Math.round(value.m ?? 0);
    if (km > 0) return `${km} km ${m} m`;
    return `${m} m`;
  }
}
